/**
 * QM8D — App Root Component
 * Reduziert auf Provider-Composition + Route-Mounting + ErrorBoundary
 * Phase 2 Refactoring: 323 -> ~30 Zeilen
 */
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';
import { ThemeProvider } from './contexts/ThemeContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { AuthProvider } from './contexts/AuthContext';
import { BrandingProvider } from './contexts/BrandingContext';
import AppRoutes from './routing/AppRoutes';
import { Toaster } from './components/ui/sonner';
import './lib/axiosClient';
import './App.css';
import './styles/brand-design-system.css';

// Skip-Navigation fuer Screenreader (WCAG 2.1 AA)
const SkipNavLink = () => (
  <a
    href="#main-content"
    className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-[9999] focus:bg-white focus:text-black focus:px-4 focus:py-2 focus:rounded-lg focus:shadow-lg focus:text-sm focus:font-medium"
    data-testid="skip-nav-link"
  >
    Zum Hauptinhalt springen
  </a>
);

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <LanguageProvider>
          <AuthProvider>
            <BrandingProvider>
              <BrowserRouter>
                <SkipNavLink />
                <AppRoutes />
              </BrowserRouter>
              <Toaster position="top-right" />
            </BrandingProvider>
          </AuthProvider>
        </LanguageProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
